import React, { useState } from 'react'
import Card from '../card/Card'
import ServiceModal from '../serviceModal/ServiceModal'

const service = [
  {
    id:1, img:'/img/service/carpet.jpeg', name:'Carpet Cleaning', discount:10,
  },
  {
    id:2, img:'/img/service/window.jpeg', name:'Window Cleaning',discount:15,
  },
  {
    id:3, img:'/img/service/domestic.jpeg', name:'Domestic Cleaning',discount:10,
  },
  {
    id:4, img:'/img/service/commercial.jpeg', name:'Commercial Cleaning',discount:15,
  },
  {
    id:5, img:'/img/service/lease.jpeg', name:'End Of Lease Cleaning',discount:10,
  },
  {
    id:6, img:'/img/service/concrete.jpeg', name:'Concrete Cleaning',discount:15,
  },
  {
    id:7, img:'/img/service/builder.jpeg', name:'Builder House Cleaning',discount:10,
  },
  {
    id:8, img:'/img/service/office.jpeg', name:'Office Cleaning',discount:15,
  },
  {
    id:9, img:'/img/service/office.jpeg', name:'BNB Cleaning',discount:15,
  },
]

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  const scrollToContact = () => {
    setSelectedService(null);
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="services section-padding" id="services">
      <div className="container">
        <div className="section-title">
          <span className="title" data-aos="fade-up">services</span>
          <h2 className="sub-title" data-aos="fade-up">Professional Cleaning Services Across Melbourne & Western Suburbs</h2>
        </div>
        <div className="grid">
          {service.map((item) => (
            <Card key={item.id} name={item.name} img={item.img} onClick={() => setSelectedService(item)} dataAos="zoom-in"
      dataAosDelay={item.id * 100} />
          ))}
        </div>
      </div>

      <ServiceModal
        isOpen={selectedService !== null}
        onClose={() => setSelectedService(null)}
        service={selectedService}
        scrollToContact={scrollToContact}
      />
    </section>
  )
}

export default Services
